<template>
  <v-content>
    <div id="core-view">
      <v-slide-x-transition mode="out-in">
        <router-view transition="slide-x-transition" />
      </v-slide-x-transition>
    </div>
    <!--<core-footer v-if="$route.name !== 'Maps'" />-->
  </v-content>
</template>

<script>
  export default {
    metaInfo() {
      return {
        title: ''
      }
    }
  }
</script>

<style>
  #core-view {
    padding-bottom: 100px;
  }
</style>



// WEBPACK FOOTER //
// VueSrc/Common/Components/materialcomponents/components/core/View.vue